import { ReactNode } from 'react';
import { IconAlertTriangle, TablerIcon } from '@rossum/ui/icons/tabler';
import { Box, Button, Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { CircleIconWrapper } from './CircleIconWrapper';
import { Radar } from './Radar';

type EmptyStateRadarProps = {
  title: ReactNode;
  description?: ReactNode;
  iconProps?: {
    Icon: TablerIcon;
    iconSize: number;
  };
  buttonProps?: {
    text: string;
    onClick: () => void;
  };
};

export const EmptyStateRadar = ({
  title,
  description,
  iconProps,
  buttonProps,
}: EmptyStateRadarProps) => {
  const { iconSize, Icon } = iconProps || {
    Icon: IconAlertTriangle,
    iconSize: 36,
  };
  const iconCircleRadius = iconSize + 32;

  return (
    <Stack
      data-cy="empty-state-radar"
      sx={{
        position: 'relative',
        justifyContent: 'center',
        flexGrow: 1,
        height: 1,
        minHeight: 200,
        overflow: 'hidden',
        mask: 'linear-gradient(0deg, transparent 5%, black 45%, black 85%, transparent 95%) no-repeat',
        WebkitMask:
          'linear-gradient(0deg, transparent 5%, black 45%, black 85%, transparent 95%) no-repeat',
      }}
    >
      <Stack
        sx={{
          position: 'absolute',
          left: '50%',
          top: '30%',
          width: '100%',
          transform: 'translate(-50%, -50%)',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Radar baseRadius={iconCircleRadius}>
          <CircleIconWrapper size={iconCircleRadius}>
            <SvgIcon sx={{ fontSize: iconSize, color: 'text.secondary' }}>
              <Icon />
            </SvgIcon>
          </CircleIconWrapper>
        </Radar>
        <Stack spacing={3} sx={{ position: 'absolute', top: '120%', pt: 1 }}>
          <Stack spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: 'text.primary' }}>
              {title}
            </Typography>
            {description ? (
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {description}
              </Typography>
            ) : null}
          </Stack>
          {buttonProps ? (
            <Box>
              <Button variant="contained" onClick={buttonProps.onClick}>
                {buttonProps.text}
              </Button>
            </Box>
          ) : null}
        </Stack>
      </Stack>
    </Stack>
  );
};
